var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#DDD2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3327 25.6667H15.3327C14.4122 25.6667 13.666 26.4129 13.666 27.3334V39.3334C13.666 40.2538 14.4122 41 15.3327 41H19.3327C20.2532 41 20.9993 40.2538 20.9993 39.3334V27.3334C20.9993 26.4129 20.2532 25.6667 19.3327 25.6667Z",
    fill: "#4B1598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9987 20.3333H25.9987C25.0782 20.3333 24.332 21.0795 24.332 22V39.3333C24.332 40.2538 25.0782 41 25.9987 41H29.9987C30.9192 41 31.6654 40.2538 31.6654 39.3333V22C31.6654 21.0795 30.9192 20.3333 29.9987 20.3333Z",
    fill: "#4B1598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 15H36.6667C35.7462 15 35 15.7462 35 16.6667V39.3333C35 40.2538 35.7462 41 36.6667 41H40.6667C41.5871 41 42.3333 40.2538 42.3333 39.3333V16.6667C42.3333 15.7462 41.5871 15 40.6667 15Z",
    fill: "#4B1598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCases);
export default __webpack_public_path__ + "static/media/use-cases.3b5ef8398c3b61b83375ef6fe06c89d8.svg";
export { ForwardRef as ReactComponent };